import Cookies from "js-cookie";

const useFetchWithToken = (rootUrl: string) => {
	const token = Cookies.get("X-RequestVerificationToken") ?? "";

	return (url: string, options: RequestInit) => {
		options = {
			...options,
			headers: {
				...options.headers,
				"X-RequestVerificationToken": token,
				"Content-Type": "application/json",
			},
		} as RequestInit;
		return fetch(rootUrl + url, options);
	};
};

export default useFetchWithToken;
